export enum ErrorMachineName {
  InvalidCredentials = 'invalid_credentials',
  EmailInUse = 'email_in_use',
  UserNotFound = 'user_not_found',
  ConfirmationCodeNotFound = 'confirmation_code_not_found',
  ConfirmationCodeExpired = 'confirmation_code_expired',
}

